/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./StudentInfo.css";
import { Box } from "@mui/system";
import { Button, Slider, TextField } from "@mui/material";
import Locale from "../../../locales";
import {
  updateRating,
  changeRating,
  changeStudentMessage,
} from "../../../redux/actions";

const StudentInfo = ({ summaryStudent }) => {
  const students = useSelector((state) => state.teacherReducer.students);
  const [studentRating, setStudentRating] = useState(0);
  const [studentMessage, setStudentMessage] = useState("");
  const [intialStudentRating, setIntialStudentRating] = useState();
  const [initialStudentMessage, setInitialStudentMessage] = useState("");
  const [studentMessageEditMode, setStudentMessageEditMode] = useState(false);
  const [studentRatingEditMode, setStudentRatingEditMode] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const currentstudentRating = students.filter(
      (el) => el.studentId === summaryStudent,
    );
    setIntialStudentRating(currentstudentRating[0]?.rating);
    setInitialStudentMessage(currentstudentRating[0]?.studentMessage);
  }, []);

  useEffect(() => {
    const currentstudentRating = students.filter(
      (el) => el.studentId === summaryStudent,
    );
    setStudentRating(currentstudentRating[0]?.rating);
    setStudentMessage(currentstudentRating[0]?.studentMessage);
  }, [students, summaryStudent]);

  const changeRatingHandler = (event, value) => {
    const newRating = parseInt(value, 10);
    dispatch(changeRating(summaryStudent, newRating));
  };

  const saveUpdatedRatingHandler = () => {
    if (studentRatingEditMode) {
      dispatch(updateRating(summaryStudent, studentRating, studentMessage));
      setStudentRatingEditMode(false);
    } else {
      setStudentRatingEditMode(true);
    }
  };

  const onStudentMessageChange = (event) => {
    dispatch(changeStudentMessage(summaryStudent, event.target.value));
  };

  const saveUpdatedMessageHandler = () => {
    if (studentMessageEditMode) {
      dispatch(updateRating(summaryStudent, studentRating, studentMessage));
      setStudentMessageEditMode(false);
    } else {
      setStudentMessageEditMode(true);
    }
  };

  const cancelRatingChange = () => {
    dispatch(changeRating(summaryStudent, intialStudentRating));
    setStudentRatingEditMode(false);
  };

  const cancelMessageChange = () => {
    dispatch(changeStudentMessage(summaryStudent, initialStudentMessage));
    setStudentMessageEditMode(false);
  };

  return (
    <div className="student-info-summary-container">
      <div className="message-container">
        <TextField
          disabled={!studentMessageEditMode}
          label={Locale.t("student_message")}
          value={studentMessage}
          onChange={onStudentMessageChange}
        />
        <div className="summary-info-message-rating-buttons-container">
          <Button
            onClick={saveUpdatedMessageHandler}
            variant="outlined"
            color={studentMessageEditMode ? "success" : "primary"}>
            {studentMessageEditMode ? Locale.t("save") : Locale.t("edit")}
          </Button>
          {studentMessageEditMode && (
            <Button
              onClick={cancelMessageChange}
              variant="outlined"
              color="error">
              {Locale.t("cancel")}
            </Button>
          )}
        </div>
      </div>
      <div className="rating-container">
        <p>{Locale.t("general_performance")}</p>
        <Box sx={{ width: "80%" }}>
          <Slider
            disabled={!studentRatingEditMode}
            key={`key-${studentRating}`}
            defaultValue={studentRating}
            getAriaValueText={() => studentRating}
            valueLabelDisplay="auto"
            min={0}
            max={100}
            onChangeCommitted={changeRatingHandler}
          />
        </Box>
        <div className="summary-info-message-rating-buttons-container">
          <Button
            onClick={saveUpdatedRatingHandler}
            variant="outlined"
            color={studentRatingEditMode ? "success" : "primary"}>
            {studentRatingEditMode ? Locale.t("save") : Locale.t("edit")}
          </Button>
          {studentRatingEditMode && (
            <Button
              onClick={cancelRatingChange}
              variant="outlined"
              color="error">
              {Locale.t("cancel")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentInfo;
